export const logoutConfig = { 
  postLogoutRedirectUri: window.location.origin + '/' 
}
